import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { buttonPrimary } from 'app/sofia/resources/theme/css'
import { Container } from '../../../SectionTitle'
import postsShapeSvg from 'resources/svg/blog-shape.svg'

export const NormalGrid = styled.div`
  ${props => props.theme.css.containerWide};
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;

  > div {
    &:first-child {
      width: 23%;
      margin-right: 2%;
      ${bp('sm')`
        width: 100%;
      `}
    }

    &:last-child {
      width: 75%;
      ${bp('sm')`
        width: 100%;
      `}
    }
  }

  .posts-grid {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    position: relative;
    height: fit-content;

    &::after {
      content: '';
      width: 350px;
      height: 750px;
      position: absolute;
      z-index: -1;
      left: -10%;
      bottom: -20%;
      background: url(${postsShapeSvg}) no-repeat;
      background-size: contain;
      ${bp('sm')`
        content: unset;
      `}
    }

    > div {
      padding: 0 0 20px;
      box-sizing: border-box;
      border-bottom: 1px solid ${props => props.theme.palette.general.grey};
      margin-bottom: 20px;
      width: 100%;
      ${bp('sm')`
        border-bottom: 1px solid ${(props: any) => props.theme.palette.general.greyDark};

        .title {
          font-size: 16px;
        }

        .image {
          ${bp('sm')`
            min-width: 100px;
            width: 40%;
            height: unset;
          `}
        }

        .content {
          max-width: 60%;
          padding: 0 10px;
        }
      `}
    }

    ${Container} {
      width: 100%;
    }
  }
`

export const FeaturedGrid = styled.div`
  ${props => props.theme.css.containerWide};

  .posts-grid {
    display: grid;
    grid-template-columns: 1.6fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 1px 1px;
    grid-template-areas:
      "featured ."
      "featured ."
      "featured .";
    box-sizing: border-box;
    margin-bottom: 15px;
    ${bp('sm')`
      display: block;
      margin-bottom: 0;
    `}

    > div {
      padding: 0 0 15px;
      box-sizing: border-box;

      &:not(:first-child) {
        margin: 0 15px;
        border-bottom: 1px solid ${props => props.theme.palette.general.grey};
        ${bp('sm')`
          border-bottom: 1px solid ${(props: any) => props.theme.palette.general.greyDark};
          margin: 0;
        `}

        > div,
        .item,
        a {
          height: 100%;
        }

        .image {
          display: none;
        }

        &:not(:last-child) {
          margin-bottom: 15px;
        }
      }

      &:first-child {
        width: 100%;
        grid-area: featured;
        padding: 0;

        .item {
          position: relative;

          > a {
            display: block;
          }

          .content {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 15px;
            text-align: left;
            color: ${props => props.theme.palette.general.light};
            ${bp('sm')`
              position: static;
              color: ${(props: any) => props.theme.palette.general.strong};
              padding: 15px 5px;
            `}

            .title {
              font: ${font('alt', 'normal', '22px/1')};
            }

            .action {
              ${buttonPrimary}
              background: ${props => props.theme.palette.general.light};
              color: ${props => props.theme.palette.primary.alphaDark};
              width: max-content;
              border: none;
              margin: 10px 0;
              ${bp('sm')`
                padding: 0;
                min-height: unset;
                font: ${font('default', 'bold', '16px/1')};

                &:hover {
                  background: transparent;
                  color: ${(props: any) => props.theme.palette.primary.alpha};
                }
              `}

              span {
                display: inline-block;
              }
            }
          }

          .image {
            height: auto;
            padding-bottom: 60%;

            &::before {
              content: '';
              width: 100%;
              background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 45%, rgba(0, 0, 0, 1) 100%);
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              height: 100%;
              ${bp('sm')`
                content: unset;
              `}
            }
          }
        }
      }

      &:nth-child(2) {
        ${bp('sm')`
          &::before {
            content: 'Featured';
            display: inline-block;
            text-transform: uppercase;
            font: ${font('default', 'bold', '16px/1')};
            margin-bottom: 15px;
            padding: 0 5px;
          }
        `}
      }
    }

    ${Container} {
      width: 100%;
    }
  }
`
